<script setup lang="ts">

import ContractDetailForm from '@/modules/contract/components/ContractDetailForm.vue'
import { computed, ref } from 'vue'
import ContractUpdateForm from '@/modules/contract/components/ContractUpdateForm.vue'
import { useContractDetailStore } from '@/modules/contract/stores/contract.detail.store.ts'
import AllowPerm from '@/onenetwork/components/perms/AllowPerm.vue';
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import { useToast } from 'primevue/usetoast'

interface Props {
  contractId: number | null
}

const props = defineProps<Props>()

const contractDetailStore = useContractDetailStore()

const contractDetail = computed(() => {
  return contractDetailStore.contracts[props.contractId]?.contract || null
})

const canEdit = computed(() => {
  return contractDetail.value && ['KHOI_TAO'].includes(contractDetail.value.status)
})
const editForm = ref<boolean>(false)

const handleEditToggle = () => {
  editForm.value = !editForm.value
}

const toast = useToast()

const settleLoading = ref(false)
const handleSettle = async () => {
  settleLoading.value = true
  try{
    const res = await APIClient.post(`/contracts/${contractDetail.value.id}`, {
      status: 'QUYET_TOAN',
      _method: 'PUT'
    })
    toast.add({ severity: 'success', summary: 'Thành công', detail: `Quyết toán thành công`, life: 2000 });
  } catch (e) {
    toast.add({ severity: 'error', summary: 'Thất bại', detail: `Quyết toán thất bại`, life: 2000 });
  } finally {
    settleLoading.value = false
  }
}

const cancelDealLoading = ref(false)
const handleCancelDeal = async () => {
  cancelDealLoading.value = true
  try{
    const res = await APIClient.post(`/contracts/${contractDetail.value.id}/cancel-deal`, {})
    toast.add({ severity: 'success', summary: 'Thành công', detail: `Huỷ deal thành công`, life: 2000 });
  } catch (e) {
    toast.add({ severity: 'error', summary: 'Thất bại', detail: `Huỷ deal thất bại`, life: 2000 });
  } finally {
    cancelDealLoading.value = false
  }
}
</script>

<template>
  <div class="flex justify-end mb-3" >
    <AllowPerm perm="contract.edit" action="hide">
      <template v-if="contractDetail?.status == 'CHOT_DEAL'">
        <button :disabled="settleLoading" class="btn btn-cs !bg-[green]" @click="handleSettle">Quyết toán</button>
<!--        <button :disabled="cancelDealLoading" class="btn btn-cs" @click="handleCancelDeal">Huỷ Deal</button>-->
      </template>
      <template v-if="canEdit">
        <button class="btn btn-cs" @click="handleEditToggle" v-if="!editForm">Chỉnh sửa</button>
        <button class="btn btn-cs" @click="handleEditToggle" v-else>Huỷ</button>
      </template>
    </AllowPerm>
  </div>
  <message severity="info" v-if="!canEdit">
    <strong>Lưu ý:</strong> Hợp đồng này hiện đã được ký và đang thực hiện, do đó, không thể chỉnh sửa thông tin hợp đồng này. Các thông tin về bên mua và số tiền hoa hồng sẽ tự động ghi nhận sau khi flash offer kết thúc.
  </message>
  <br/>
  <template v-if="!editForm">
    <ContractDetailForm :contractId="props.contractId" />
  </template>
  <template v-else>
    <ContractUpdateForm action="update" :listing-id="null" :contractId="props.contractId"/>
  </template>
</template>

<style scoped>

</style>
